import React, { memo } from 'react';

function MockWindow({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="brand-landing-mock">
      <div className="brand-landing-mock__chrome">
        <span className="brand-landing-mock__dots" aria-hidden="true">
          <i />
          <i />
        </span>
        <span className="brand-landing-mock__chrome-title">{title}</span>
        <span className="brand-landing-mock__chrome-badge">Preview</span>
      </div>
      <div className="brand-landing-mock__body">{children}</div>
    </div>
  );
}

export const WorkflowMockBuild = memo(function WorkflowMockBuild() {
  return (
    <MockWindow title="New Brand project · Step 1">
      <p className="brand-landing-mock__label">Brand setup</p>
      <div className="brand-landing-mock__field">
        <span>Brand name</span>
        <strong>Northstar Analytics</strong>
      </div>
      <div className="brand-landing-mock__field">
        <span>Website</span>
        <strong>northstaranalytics.example</strong>
      </div>
      <div className="brand-landing-mock__field">
        <span>Aliases</span>
        <strong>Northstar · NSA</strong>
      </div>
      <div className="brand-landing-mock__footer">
        <span>Used for prompts, claims, and disambiguation.</span>
        <span className="brand-landing-mock__btn">Continue</span>
      </div>
    </MockWindow>
  );
});

export const WorkflowMockGenerate = memo(function WorkflowMockGenerate() {
  return (
    <MockWindow title="Guided setup · Generating">
      <p className="brand-landing-mock__label">Ready to review</p>
      <ul className="brand-landing-mock__list">
        <li className="is-done">
          <span>Competitors</span>
          <em>8 drafted</em>
        </li>
        <li className="is-done">
          <span>Buyer prompts</span>
          <em>24 drafted</em>
        </li>
        <li className="is-done">
          <span>Fact sheet</span>
          <em>35 facts</em>
        </li>
      </ul>
      <div className="brand-landing-mock__footer">
        <span>Edit anything before you run.</span>
        <span className="brand-landing-mock__btn">Review</span>
      </div>
    </MockWindow>
  );
});

export const WorkflowMockAudit = memo(function WorkflowMockAudit() {
  return (
    <MockWindow title="Audit run · Live">
      <p className="brand-landing-mock__label">Engines</p>
      <div className="brand-landing-mock__engines">
        <div>
          <strong>ChatGPT</strong>
          <span>12 / 24</span>
        </div>
        <div>
          <strong>Gemini</strong>
          <span>18 / 24</span>
        </div>
        <div>
          <strong>Perplexity</strong>
          <span>9 / 24</span>
        </div>
      </div>
      <div className="brand-landing-mock__footer">
        <span>Same prompts across every engine.</span>
        <span className="brand-landing-mock__btn brand-landing-mock__btn--soft">Running</span>
      </div>
    </MockWindow>
  );
});

export const WorkflowMockAct = memo(function WorkflowMockAct() {
  return (
    <MockWindow title="Claims · Worklist">
      <p className="brand-landing-mock__label">Priority fixes</p>
      <ul className="brand-landing-mock__list">
        <li>
          <span>False pricing claim</span>
          <em className="is-bad">High</em>
        </li>
        <li>
          <span>Stale Salesforce sync note</span>
          <em>Medium</em>
        </li>
        <li>
          <span>Missing from category shortlist</span>
          <em>Medium</em>
        </li>
      </ul>
      <div className="brand-landing-mock__footer">
        <span>Fix sources, then re-run for Drift.</span>
        <span className="brand-landing-mock__btn">Open worklist</span>
      </div>
    </MockWindow>
  );
});
